export default __webpack_public_path__ + "static/media/logo_sw.f7608158.svg";